import { FormProvider, useForm } from 'react-hook-form'

import {
  Form,
  FormError,
  Link,
  OperationButton,
  Password,
  Username,
  UsernameField
} from '@/components/core-v2'
import { PasswordField } from '@/components/core-v2/molecules/fields/password'
import { PATH } from '@/const'
import { useAADLogin } from '@/utilities/hooks/useAADLogin'
import { useLogin } from '@/utilities/hooks/useLogin'

import { COPY } from './constants'
import classes from './index.module.scss'

export type LoginFields = UsernameField & PasswordField

export const LoginForm = () => {
  const form = useForm<LoginFields>()
  const [onSubmit, { error, isError, isLoading }] = useLogin({
    redirectOnSuccess: true,
    redirectOnLockedOut: true
  })

  const isInvalidCredentialsError = isError && 'status' in error && error.status === 401

  const { aadButtonText, aadError, aadLogin, aadLogout, isAuthenticated } = useAADLogin()

  return (
    <section className={classes.root}>
      <FormProvider {...form}>
        <Form aria-busy={isLoading} name="Login form" onSubmit={form.handleSubmit(onSubmit)}>
          <Username className="mb-4" isDisabled={isLoading} />
          <Password isDisabled={isLoading} />
          <Link className={classes.resetPassword} tabIndex={0} to={PATH.resetPasswordRequest}>
            {COPY.forgotPassword}
          </Link>

          <FormError
            className={classes.errorAlert}
            isShowing={isInvalidCredentialsError}
            title="Error"
          >
            {COPY.invalidCredentials}
          </FormError>

          <OperationButton
            isDisabled={isLoading}
            isLoading={isLoading}
            operationType="progress"
            type="submit"
            width="100%"
          >
            {COPY.continue}
          </OperationButton>

          <h2>Single Sign On</h2>

          {aadButtonText && (
            <>
              {isAuthenticated ? (
                <OperationButton
                  isDisabled={false}
                  isLoading={false}
                  operationType="progress"
                  type="button"
                  width="100%"
                  onClick={aadLogout}
                >
                  AAD Logout
                </OperationButton>
              ) : (
                <OperationButton
                  isDisabled={false}
                  isLoading={false}
                  operationType="progress"
                  type="button"
                  width="100%"
                  onClick={aadLogin}
                >
                  {aadButtonText}
                </OperationButton>
              )}
              {aadError?.length && <div className={classes.errorAlert}>{aadError}</div>}
            </>
          )}
        </Form>
      </FormProvider>
    </section>
  )
}
